<ms-dropdown
    #dropdown
    [options]="options"
    [optionTemplate]="optionTemplate"
    [titleTemplate]="titleTemplate"
    [viewport]="viewport"
    [dropdownPlacement]="dropdownPlacement"
    (optionChange)="optionChanged($event)"
    (dropdownState)="toggleDropdown($event)" />
<ng-template #titleTemplate>
    @if (active && active.teamId && imagesMap[active.teamId]) {
        <ms-participant-image [showFallback]="true" [participantImage]="imagesMap[active.teamId]" [sportId]="imagesMap[active.teamId].sportId" />
    }
    <span class="multi-column-title-text" [class.has-image]="active && active.teamId && imagesMap[active.teamId]"> {{ active?.name }} </span>
</ng-template>
<ng-template #optionTemplate let-group>
    <div
        [ngClass]="{
            'multi-column-header': group.id === header.id,
            'multi-column-any': group.id === any?.id,
            'multi-column-group': group.id !== header.id && group.id !== any?.id,
            'text-center': textAlignment === 'center',
        }">
        @for (option of group.payload; track option.id) {
            <div
                class="multi-column-option"
                [ngClass]="{
                    'multi-column-option--selected': option.id === active?.id,
                    'multi-column-option--disabled': option.disabled,
                }"
                (click)="dropdown.selectOption(option)">
                @if (imagesMap[option.id]) {
                    <ms-participant-image [showFallback]="true" [participantImage]="imagesMap[option.id]" [sportId]="imagesMap[option.id].sportId" />
                }
                {{ option.name }}
            </div>
        }
    </div>
</ng-template>
